import React from 'react';

function SubWrapper({ className, children }) {
  return <div className={`${className} relative sm_ss:px-4 sm_s:px-0 `}>{children}</div>;
}

export default SubWrapper;
